import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglass } from "@fortawesome/free-regular-svg-icons";
import { useState, useEffect, useContext, useRef } from "react";
import EndOfVotingTimeContext from "../context/EndOfVotingTimeContext";
import styles from "./Timer.module.scss";
function Timer(props) {
  const [time, setTime] = useState(props.time);
  const timeRef = useRef();
  const { endOfVotingTime, setEndOfVotingTime } = useContext(
    EndOfVotingTimeContext
  );

  function prependWithZero(number) {
    return ("0" + number).slice(-2);
  }

  useEffect(() => {
    timeRef.current = time;
  });

  useEffect(() => {
    if (endOfVotingTime === null){
      setTime(0);
    }else{
      let startingTime = endOfVotingTime.updateTime - Date.now() + endOfVotingTime.timeTillNextVoting; 
      setTime(Math.round(startingTime / 1000));
      const interval = setInterval(() => {
        setTime((prev_time) => Math.max(0, prev_time - 1));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [endOfVotingTime]);

  return (
    <div className={styles.container}>
      <div>
        <p>Voting ends in:</p>
        <div className={styles.clock}>
          <p>
            {prependWithZero(Math.floor(time / 60))}:
            {prependWithZero(time % 60)}
            <span> </span>
            <FontAwesomeIcon icon={faHourglass} />
          </p>
        </div>
      </div>
    </div>
  );
}

export default Timer;
